import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import MobileContext from 'context/MobileContext';
import { backArrowDesktop, backArrowMobile, fsfLogo } from 'assets/newIcons';
import styles from './HeaderOnboarding.module.css';

const HeaderOnboarding = ({ showBackButton, onBackClick }) => {
  const isMobile = useContext(MobileContext);

  return (
    <div className={styles.container}>
      <div className={`${styles.headerContainer} ${isMobile ? styles.mob : ''}`}>
        {showBackButton && (
          <div className={`${styles.backButtonContainer} ${isMobile ? styles.mob : ''}`}>
            <img
              alt="Back"
              onClick={onBackClick}
              className={`${styles.backArrow} ${isMobile ? styles.mob : ''}`}
              src={isMobile ? backArrowMobile : backArrowDesktop}
            />
          </div>
        )}
        <div className={styles.logoContainer}>
          <img
            src={fsfLogo}
            alt="logo"
            className={`${styles.logo} ${isMobile ? styles.mob : ''}`}
          />
        </div>
      </div>
    </div>
  );
};

HeaderOnboarding.propTypes = {
  showBackButton: PropTypes.bool,
  onBackClick: PropTypes.func,
};

HeaderOnboarding.defaultProps = {
  showBackButton: false,
  onBackClick: () => {},
};

export default HeaderOnboarding;
